export default __webpack_public_path__ + "static/media/img-news-2.6ef03d13.png";